interface Props {
  size?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function PickleballIcon({ size = 24, className, style }: Props) {
  const brown = '#6B3520';
  const yellow = '#F5D800';

  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      style={style}
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Paddle — drawn upright, rotated -20° CCW around throat (35,50) */}
      <g transform="translate(35,50) rotate(20) translate(-35,-50)">
        {/* Full paddle silhouette: head + throat + handle as one path.
            White stroke behind brown fill creates the glowing outline. */}
        <path
          d="M 15 20 Q 15 4 35 4 Q 55 4 55 20
             L 55 42 Q 55 55 45 57
             L 45 88 Q 45 95 35 95 Q 25 95 25 88
             L 25 57 Q 15 55 15 42 Z"
          fill={brown}
          stroke="white"
          strokeWidth="8"
          strokeLinejoin="round"
          style={{ paintOrder: 'stroke fill' }}
        />
        {/* Inner face ring — white outline inset on the paddle head */}
        <path
          d="M 21 22 Q 21 11 35 11 Q 49 11 49 22
             L 49 41 Q 49 47 35 47 Q 21 47 21 41 Z"
          fill="none"
          stroke="white"
          strokeWidth="3"
        />
        {/* Grip wrap lines on handle */}
        <line x1="26" y1="65" x2="44" y2="65" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
        <line x1="26" y1="72" x2="44" y2="72" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
        <line x1="26" y1="79" x2="44" y2="79" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
        <line x1="26" y1="86" x2="44" y2="86" stroke="white" strokeWidth="2.5" strokeOpacity="0.55" />
      </g>

      {/* Ball — brown ring outline + yellow fill */}
      <circle cx="73" cy="62" r="19" fill={brown} />
      <circle cx="73" cy="62" r="16" fill={yellow} />
      {/* Holes scattered in pickleball pattern */}
      <ellipse cx="64" cy="54" rx="2.8" ry="3.2" fill={brown} />
      <ellipse cx="73" cy="53" rx="2.8" ry="2.5" fill={brown} />
      <ellipse cx="82" cy="55" rx="2.8" ry="3.2" fill={brown} />
      <ellipse cx="62" cy="63" rx="2.5" ry="3"   fill={brown} />
      <ellipse cx="73" cy="62" rx="2.5" ry="2.5" fill={brown} />
      <ellipse cx="83" cy="63" rx="2.5" ry="3"   fill={brown} />
      <ellipse cx="65" cy="72" rx="2.8" ry="3.2" fill={brown} />
      <ellipse cx="75" cy="73" rx="2.8" ry="2.5" fill={brown} />

      {/* Motion swoosh lines — sweep upper-left to lower-right below ball */}
      <path d="M 48 70 Q 60 72 80 70" stroke={brown} strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M 46 77 Q 59 79 82 77" stroke={brown} strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M 44 84 Q 58 87 83 84" stroke={brown} strokeWidth="3" fill="none" strokeLinecap="round" />
    </svg>
  );
}
